$(function(){
 var shrinkHeader = 100;
  $(window).scroll(function() {
    var scroll = getCurrentScroll();
      if ( scroll >= shrinkHeader ) {
           $('.nav-bar').addClass('f-shrink');
        }
        else {
            $('.nav-bar').removeClass('f-shrink');

        }
  });
function getCurrentScroll() {
    return window.pageYOffset || document.documentElement.scrollTop;
    }
  
  $('body').on('click', '.cart-template [name="checkout"], .cart-template [name="goto_pp"], .cart-template [name="goto_gc"]', function() {
    if ($('#agree').is(':checked'))
    {
      $(this).submit();
    }
    else
    {
      swal("Checkout","Please agree with the terms & conditions and privacy policy prior to check out.","warning");
      return false;
    }});
	
  
});


$('body').on('click', '.modal-open', function(e) {
    
    $('.modal-background, .modal').show();

})
.on('click', '.modal-close', function(e) {
    
    $('.modal-background, .modal').hide();

});

if ( !$('.modal-background.modal-close').length ) {
    $('<div/>').addClass('modal-background modal-close').appendTo('body');
}

// $('.rb-close').click(){
//   $('.modal-background').hide();
// });
$(".rb-close").click(function(){
        $(".modal-background").hide();
    });

// $(".modal-background").click(function(){
//         $(".rb-overlay").hide();
//     });